module.exports = __webpack_public_path__ + "img/Unidad5-4.258c3531.png";